import { render, staticRenderFns } from "./NewEditClue.vue?vue&type=template&id=4c32ae8e&scoped=true&"
import script from "./NewEditClue.vue?vue&type=script&lang=js&"
export * from "./NewEditClue.vue?vue&type=script&lang=js&"
import style0 from "./NewEditClue.vue?vue&type=style&index=0&id=4c32ae8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32ae8e",
  null
  
)

export default component.exports